<template>
 <CRUDList
  ref="crudList"
  class="tax-general-details-payment-crudlist"
  noResultOverride="No payments found"
  :canAdd="false"
  :canEdit="true"
  :canSave="canActOnTaxRecord"
  :selectedItems="selectedItems"
  :showSelect="false"
  :displayTopPagination="false"
  :hideDefaultFooter="true"
  :enableFixedHeaders="true"
  :disableKeyboardFunc="false"
  :headers="headers"
  :baseCrudKey="baseCrudKey"
  :defaultSortBy="defaultSortBy"
  :uploadFileParams="uploadFileParams"
  :variableToChangeRowBgColor="[{ varName: 'posted', varCol: '#ffe5006b' }]"
  tableWrapperDynamicClassname="taxroll-table-wrapper-two"
  :tableDynamicHeight="getHeight"
  @upsertItem="upsertRecords"
  @activateItem="activateTransaction"
  @emitSelectedItem="emitSelectedItem"
  @onDoubleClicked="handleDoubleClick"
  :loadingData="gridLoading.flag"
  :loadingText="gridLoading.text"
>
  <template v-slot:[`editedItem`]="{}">
    <TaxRollPaymentsDialog
      class="tax-general-details-payment-dialog"
      id="taxGeneralDetailsPaymentDialog"
      :baseCrudKey="baseCrudKey"
      :baseCrudKeyOfMainParent="baseCrudKeyOfMainParent"
      :baseCrudKeyForFeeList="baseCrudKeyForFeeList"
      v-model="editedItem.paymentDetails"
      :selItem="selItem"
      :taxDetBaseCrudKey="taxDetBaseCrudKey"
      :taxPayBaseCrudKey="taxPayBaseCrudKey"
    />
  </template>

  <!-- Upload, Print Paid Receipt and Email Paid Receipt are all actions the sterilised
       view-only persona does not get; the payment rows themselves stay readable. -->
  <template v-if="canActOnTaxRecord" v-slot:[`additionalActions`]="{}">
    <UploadFile
      class="mtgtrans uploadFile tax-general-details-payment-upload"
      id="taxGeneralDetailsPaymentUploadFile"
      text
      :bucketName="attachmentConstants.bucketName"
      :program="attachmentConstants.program"
      :parentObjectType="attachmentConstants.parentObjectType"
      :parentObjectId="getActiveTransID || ''"
      :itemIsSaved="!isNewItem"
    >
      <template v-slot:activator="{ activatorProps }">
        <v-btn
          class="input-text-size tax-general-details-payment-upload-btn"
          id="taxGeneralDetailsPaymentUploadBtn"
          text
          color="blue darken-1"
          @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
          @click="imagesLeftClick(activatorProps.leftClick)"
        >
          {{ activatorProps.caption }}
        </v-btn>
      </template>
    </UploadFile>

    <v-btn
      class="input-text-size tax-general-details-payment-print-btn"
      id="taxGeneralDetailsPaymentPrintBtn"
      text
      color="blue darken-1"
      @click="printReceiptOutsideDialogBox"
    >
      Print Paid Receipt
    </v-btn>
    <v-btn
      class="input-text-size tax-general-details-payment-print-btn"
      id="taxGeneralDetailsPaymentPrintBtn"
      text
      color="blue darken-1"
      @click="emailStatementReceipt"
    >
      Email Paid Receipt
    </v-btn>
    <CRUDDialog
      :baseCrudKey='emailStatements'
      :canSave="true"
      :onlyDialogHeaderName="emailStatementHeader"
      dialogDynamicWidth='550'
      canSaveCustomLabel="Send"
      @upsertItem="handleEmailStatements"
    ><template v-slot:[`editedItem`]="{}">
        <EmailStatementDialoge :baseCrudKey="emailStatements" />
      </template>
    </CRUDDialog>

  </template>
</CRUDList>

</template>
<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import '../../../../../assets/style.css';
import { clients } from '../../../../../util/clients';
import { printerHandler } from '../../../../../util/pdf-to-printer.util';
import { defaultGridLoading, manageGridLoading } from '../../../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../../../util/workstation-util';
import CRUDDialog from '../../../../common/base/crud-2.0/CRUDDialog.vue';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { TaxViewOnlyMixin } from '../../TaxInquiryUtils/taxViewOnly.mixin';
import { generateQueryString } from '../../../../common/base/report/report-util';
import UploadFile from '../../../../common/UploadFile.vue';
import EmailStatementDialoge from '../../Common/EmailStatementDialoge.vue';
import { paymentsRecordsHeaders } from '../../TaxInquiryUtils/TableHeaders.utils';
import TaxRollPaymentsDialog from './TaxRollPaymentsDialog.vue';

const { backendRest } = clients.direct;
export default {
  name: 'GeneralDetailsPayments',
  mixins: [TaxViewOnlyMixin],
  components: {
    CRUDList,
    CRUDDialog,
    TaxRollPaymentsDialog,
    UploadFile,
    EmailStatementDialoge,
  },
  data() {
    return {
      baseCrudKey: 'GeneralDetailsPayments',
      taxDetBaseCrudKey: 'taxDetPaymentsRecords',
      taxPayBaseCrudKey: 'taxPayPaymentsRecords',
      headers: this.buildHeaders(),
      gridLoading: defaultGridLoading(),
      activeTransItem: null,
      attachmentConstants: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileParams: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileClickParams: {
        leftClickFlag: false,
        leftClickDef: undefined,
        rightClickFlag: false,
        rightClickDef: undefined,
      },
      emailStatementHeader: 'Email Send',
      emailStatements: 'emailStatements',

    };
  },
  props: {
    getHeight: {
      type: String,
      default: '190',
    },
    selItem: {
      type: Object,
      default: () => ({}),
    },
    baseCrudKeyOfMainParent: {
      type: String,
      default: 'TaxInquiryDialog',
    },
    // Threaded through to the reversal dialog so it can refresh the host's fee list too.
    baseCrudKeyForFeeList: {
      type: String,
      default: 'baseCrudKeyForFeeList',
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item', 'index', 'isVisible',
    ]),
    ...mapGetters('auth/token', ['authUser']),
    ...mapState({
      StoreSelItems: (state) => state.tax.taxInquires.selectedPamentsRecords,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
      // isVisible: (state) => state.base.crud.isVisible.paymentTransactionList,
    }),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedPamentsRecords(value);
      },
    },
    editEmailItemStatements: {
      get() {
        return this.item(this.emailStatements);
      },
      set(value) {
        this.setItem([this.emailStatements, value]);
      },
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    defaultSortBy() {
      return [
        {
          column: 'name',
          direction: 'desc',
        },
      ];
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    popupVisible() {
      const isVisible = this.isVisible(this.baseCrudKey);
      return isVisible;
    },
  },
  methods: {
    manageGridLoading,
    buildHeaders(showReceipt) {
      const useReceipt = showReceipt !== undefined
        ? showReceipt
        : ((this.paymentSettingItem || {}).showReceiptNumberOnPaymentScreen || false);
      return paymentsRecordsHeaders.map((h) => {
        if (h.value === 'payment') {
          return useReceipt
            ? { ...h, text: 'Receipt #', value: 'reciept' }
            : h;
        }
        return h;
      });
    },
    ...mapActions(['reAuth', 'custumColrFlashMsg']),
    ...mapMutations('base/crud', [
      'setCriteria', 'setItems', 'setItem', 'setIsVisible',
    ]),
    ...mapMutations('tax/taxInquires', [
      'setSelectedPamentsRecords',
    ]),
    ...mapActions('tax/taxPayment', [
      'upsertOnlyPaidByPayment',
      'loadTaxPayments',
    ]),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapActions('tax/taxPayment', [
      'sendPrintReceiptToEMail',
    ]),
    // Over 100 details the backend (taxPayments.util paymentRecordsDestructured) already ships
    // just the one detail that paid the tax record being viewed, with taxDetailsCount holding
    // how many there really are - so the preview still opens, partial. TaxRollPaymentsDialog
    // reads that count off the payment row to say what is being shown.
    handleDoubleClick(items) {
      this.setItems([this.taxDetBaseCrudKey, items.taxDetails || []]);
    },
    async upsertRecords(item) {
      if (item.paymentDetails.length) {
        const idWithPaidBy = (item.paymentDetails || [])
          .map((dt) => ({ _id: dt._id, paidBy: dt.paidBy }));
        const payItem = {
          _id: item._id,
          paymentDetails: idWithPaidBy,
          curWkst: getWorkstationNumber(),
          userName: this.authUser,
          taxYear: this.selItem.taxYear,
          taxId: this.selItem.taxId,
          taxInquiryTransaction: this.selItem._id,
        };
        await this.upsertOnlyPaidByPayment({
          item: payItem,
          baseCrudKey: this.baseCrudKey,
        });
        if (this.selItem.taxYear && this.selItem.taxId) {
          const criteria = { taxYear: this.selItem.taxYear, taxId: this.selItem.taxId };
          this.loadTaxPayments({ criteria, baseCrudKey: this.baseCrudKey });
        }
      }
    },
    async imagesLeftClick(leftClick) {
      if (this.isNewItem) {
        await this.$refs.crudList.$refs.crudDialog.apply();
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNewItem) {
        await this.$refs.crudList.$refs.crudDialog.apply();
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
      } else {
        rightClick();
      }
    },
    activateTransaction(val) {
      this.activeTransItem = val;
    },
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: this.editedItem._id,
      });
    },
    async printReceiptOutsideDialogBox() {
      if (this.editedItem._id) {
        const paymentId = this.editedItem._id;
        const { jwt } = await this.reAuth();
        const params = [
          `paymentId=${paymentId}`,
          `token=${jwt}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/taxpayment/print-paid-receipt${queryString}`;
        // window.open(url, '_blank');
        printerHandler(this, { url, reportName: 'paidReceipts', deafultPrinterMode: true });
      } else this.custumColrFlashMsg({ msg: 'Please select a record' });
    },
    async emailStatementReceipt() {
      if (this.editedItem._id) {
        // Set up the email dialog data with payment information
        const emailData = {
          paymentId: this.editedItem._id,
          emailAdd: '',
          bccEmailAddress: (this.paymentSettingItem || {}).bccEmailAddress,
          subjectLine: (this.paymentSettingItem || {}).subjectLine,
          subjectBody: (this.paymentSettingItem || {}).subjectBody,
        };

        // Set the item in the store for the email dialog
        this.setItem([this.emailStatements, emailData]);

        // Open the email dialog
        this.setIsVisible([this.emailStatements, true]);
      } else {
        this.custumColrFlashMsg({ msg: 'Please select a record' });
      }
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async handleEmailStatements() {
      const {
        bccEmailAddress, emailAdd, subjectBody, subjectLine, paymentId, penaltyDate,
      } = this.editEmailItemStatements;
      const { jwt } = await this.reAuth();

      const item = {
        email: emailAdd,
        bccEmailAddress,
        subject: subjectLine,
        subjectBody,
        paymentId,
        token: jwt,
        wkst: getWorkstationNumber(),
        penaltyDate,
      };
      this.sendPrintReceiptToEMail({ item });
      // alert('handle email', item);
    },
  },
  watch: {
    'paymentSettingItem.showReceiptNumberOnPaymentScreen': {
      handler(val) {
        this.headers = this.buildHeaders(val);
      },
      immediate: true,
    },
    popupVisible(val) {
      if (val) {
        if (this.editedItem._id) this.loadFiles();
      }
    },
  },
};
</script>
